export const searchSuggestionsZIndex = 3;

export const controlsZIndex = 3;

export const searchZIndex = 5;
export const popupZIndex = 1300;

export const snackbarZIndex = 1300;

export const importSurfaceZIndex = 2;

export const trialStatusSnackbarZIndex = importSurfaceZIndex - 1;
